import { IRegistrableInstance } from './Registrable'
import { onDragstart, onDragend, onTouchstart, onTouchmove, onTouchend, onPress, onPressHoldEnd } from './handlers'

import isMobile from '../isMobile'

class Draggable extends IRegistrableInstance {
  constructor (el, component) {
    super()
    this.el = el
    this.component = component

    this.onDragstart = onDragstart.bind(this, component, el)
    this.onDragend = onDragend.bind(this, el)

    this.onTouchstart = onTouchstart.bind(this, el)
    this.onTouchmove = onTouchmove
    this.onTouchend = onTouchend

    this.onPress = onPress.bind(this, this.component.item)
    this.onPressHoldStart = onDragstart.bind(this, component, el)
    this.onPressHoldEnd = onPressHoldEnd.bind(this, this.el, this.component.item)
  }

  registered () {
    isMobile() ? this._registerMobileListeners() : this._registerListeners()
  }

  unregistered () {
    isMobile() ? this._unregisterMobileListeners() : this._unregisterListeners()
  }

  _registerListeners () {
    this.el.addEventListener('dragstart', this.onDragstart)
    this.el.addEventListener('dragend', this.onDragend)
  }

  _unregisterListeners () {
    this.el.removeEventListener('dragstart', this.onDragstart)
    this.el.removeEventListener('dragend', this.onDragend)
  }

  _registerMobileListeners () {
    this.el.addEventListener("touchstart", this.onTouchstart, false);
    this.el.addEventListener('touchmove', this.onTouchmove, false)
    this.el.addEventListener("touchend", this.onTouchend, false);

    this.el.addEventListener('pressEnd', this.onPress)
    this.el.addEventListener('pressHoldStart', this.onPressHoldStart)
    this.el.addEventListener('pressHoldEnd', this.onPressHoldEnd)
  }

  _unregisterMobileListeners () {
    this.el.removeEventListener('touchstart', this.onTouchstart, false)
    this.el.removeEventListener('touchmove', this.onTouchmove, false)
    this.el.removeEventListener('touchend', this.onTouchend, false)

    this.el.removeEventListener('pressEnd', this.onPress)
    this.el.removeEventListener('pressHoldStart', this.onPressHoldStart)
    this.el.removeEventListener('pressHoldEnd', this.onPressHoldEnd)
  }
}

export default Draggable
